import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import AOS from 'simple-aos';

/*
 * Initialize AOS (Animate On Scroll)
 */
AOS.init({
	disable: window.matchMedia('(prefers-reduced-motion: reduce)'), // reduce motion when user has set prefers-reduced-motion for accessibility
	easing: 'ease-out',
	duration: 800,
	offset: 80,
	anchorPlacement: 'top-bottom',
	once: true,
});

/*
 * Employee Groups Slider
 */
const ergSection = document.querySelector('.erg-section');
const ergSlider = document.querySelector('.erg-slider');
if (ergSlider && ergSection) {
	// Background gradients for each slide
	const slideBackgrounds = [
		'linear-gradient(270deg, #0157F0 47.99%, #01399E 100%)', // Slide 1
		'linear-gradient(270deg, #08335E 0%, #01399E 100%)', // Slide 2
		'linear-gradient(270deg, #0056F0 0%, #1088FF 100%)', // Slide 3
		'linear-gradient(270deg, #BB61FF 0%, #01399E 100%)', // Slide 4
		'linear-gradient(270deg, #01399E 0%, #1088FF 100%)', // Slide 5
		'linear-gradient(270deg, #0157F0 0%, #002852 100%)', // Slide 6
		'linear-gradient(270deg, #B6EEFF 0%, #0056F0 100%)', // Slide 7
	];

	// Initialize Swiper
	// eslint-disable-next-line no-new
	new Swiper('.erg-slider', {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		on: {
			// Change background on slide change
			slideChange() {
				const { realIndex } = this;
				if (slideBackgrounds[realIndex]) {
					ergSection.style.background = slideBackgrounds[realIndex];
				}
			},
		},
	});
}

/*
 * Charitable Organizations Logos Swiper
 * Infinite smooth autoplay carousel
 */
const charitableLogos = document.querySelector('.charitable-logos-swiper');
if (charitableLogos) {
	// eslint-disable-next-line no-new
	new Swiper('.charitable-logos-swiper', {
		modules: [Autoplay],
		slidesPerView: 2,
		spaceBetween: 20,
		loop: true,
		loopAdditionalSlides: 5,
		speed: 7000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		allowTouchMove: true,
		freeMode: {
			enabled: true,
			momentum: false,
		},
		breakpoints: {
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			992: {
				slidesPerView: 5,
			},
		},
	});
}
